import type { RoleSelectionListKey } from '../../../../shared/selection-lists/types';

/**
 * TaxonomyTree level ids for the role taxonomy. Matches
 * `ROLE_TAXONOMY_SELECTION_LIST_IDS` (k7 → k150 → k1500 → k15000): only the
 * odd-indexed `role_level_*` filters correspond to a tree depth; the
 * intermediate even-indexed filters (`role_level_2`, `_4`, `_6`) share the
 * next depth with the surrounding odd tier (see
 * `roleBreakdownTierFromDeepestFilter`).
 */
export const ROLE_TAXONOMY_TREE_LEVELS: number[] = [1, 3, 5, 7];

export const ROLE_TAXONOMY_SELECTION_LIST_IDS: RoleSelectionListKey[] = [
  'role_k7',
  'role_k150',
  'role_k1500',
  'role_k15000',
];

export const ROLE_FINE_TAXONOMY_TREE_LEVELS: number[] = [1, 3, 5, 6, 7];

/** k150 -> k1500 -> k5000 */
export const ACTIVITY_TAXONOMY_TREE_LEVELS: number[] = [3, 5, 6];

/**
 * TaxonomyTree level ids for the geography taxonomy (Region → Country →
 * MSA/State → City). The State-vs-MSA branch is selected by the geography
 * taxonomy id (see `GEOGRAPHY_TAXONOMY_ID_BY_MODE`).
 */
export const GEOGRAPHY_TAXONOMY_TREE_LEVELS: number[] = [1, 2, 3, 4];
